import type { createBrowserRouter } from 'react-router-dom';

type AppRouter = ReturnType<typeof createBrowserRouter>;

/**
 * Registry for the app's router instance (created in main.tsx). Lets
 * infrastructure that lives outside the component tree — currently the
 * public sample experience's navigation guard — observe and drive
 * navigation without occupying the single useBlocker slot that product
 * views (note save guard, patient edit session) already use.
 */
let appRouter: AppRouter | null = null;

export const setAppRouter = (router: AppRouter): void => {
  appRouter = router;
};

export const getAppRouter = (): AppRouter | null => appRouter;
